import { createFileRoute } from '@tanstack/react-router';

import ExportTemplates from '@/areas/sourcing-scenarios/ExportTemplates/ExportTemplatesPage';
import { canViewExportTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/export')({
    staticData: { access: { permissions: canViewExportTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ExportTemplates />;
}
